import React, { lazy } from 'react';

const Home                        = lazy(() => import('./pages/Home'));
const Sanita                      = lazy(() => import('./pages/Sanita'));
const AiSanita                    = lazy(() => import('./pages/AiSanita'));
const Longevity                   = lazy(() => import('./pages/Longevity'));
const MedTourism                  = lazy(() => import('./pages/MedTourism'));
const AgevolazioniFinanziamenti   = lazy(() => import('./pages/AgevolazioniFinanziamenti'));
const SviluppoImpresa             = lazy(() => import('./pages/SviluppoImpresa'));
const RicercaSviluppo             = lazy(() => import('./pages/RicercaSviluppo'));
const Formazione                  = lazy(() => import('./pages/Formazione'));
const StartupPoc                  = lazy(() => import('./pages/StartupPoc'));
const MaDueDiligence              = lazy(() => import('./pages/MaDueDiligence'));
const NuoveInfrastrutture         = lazy(() => import('./pages/NuoveInfrastrutture'));
const ProgettiEsteri              = lazy(() => import('./pages/ProgettiEsteri'));
const ClubDeal                    = lazy(() => import('./pages/ClubDeal'));
const Investimenti                = lazy(() => import('./pages/Investimenti'));
const ChiSiamo                    = lazy(() => import('./pages/ChiSiamo'));
const Contatti                    = lazy(() => import('./pages/Contatti'));
const GlobalProjects              = lazy(() => import('./pages/GlobalProjects'));
const NorthernMetropolis          = lazy(() => import('./pages/NorthernMetropolis'));

const routes = [
  {
    name: 'Home',
    path: '/',
    element: <Home />,
    menu: false,
  },

  // ── Health & Wellbeing ─────────────────────────────────────────
  {
    name: 'Sanità',
    path: '/sanita',
    element: <Sanita />,
    menu: true,
    group: 'health',
    desc: 'Hub sanità: R&D, DTx, 3D, AI, Digital Twin, Longevity, Medical Tourism.',
  },
  {
    name: 'AI in Sanità',
    path: '/sanita/ai',
    element: <AiSanita />,
    menu: true,
    group: 'health',
    desc: 'Intelligenza artificiale applicata alla medicina personalizzata e di precisione e per l\'efficientamento dei processi clinici e amministrativi.',
  },
  {
    name: 'Longevity',
    path: '/longevity',
    element: <Longevity />,
    menu: true,
    group: 'health',
    desc: 'Supporto al paziente autonomo: monitoraggio, prevenzione e digital health.',
  },
  {
    name: 'Medical Tourism',
    path: '/med-tourism',
    element: <MedTourism />,
    menu: true,
    group: 'health',
    desc: 'Modelli hotel-ambulatorio e percorsi wellness integrati di qualità.',
  },
  {
    name: 'Agevolazioni e Finanziamenti',
    path: '/agevolazioni-finanziamenti',
    element: <AgevolazioniFinanziamenti />,
    menu: true,
    group: 'health',
    desc: 'Incentivi pubblici e privati per la transizione 4.0/5.0 in sanità.',
  },
  {
    name: 'Sviluppo Impresa',
    path: '/sviluppo-impresa',
    element: <SviluppoImpresa />,
    menu: true,
    group: 'health',
    desc: "Dalla fattibilità all'apertura fino al controllo di gestione.",
  },
  {
    name: 'Ricerca & Sviluppo',
    path: '/ricerca-sviluppo',
    element: <RicercaSviluppo />,
    menu: true,
    group: 'health',
    desc: "Ricerca applicata, brevetti e incentivi per l'innovazione.",
  },
  {
    name: 'Formazione',
    path: '/formazione',
    element: <Formazione />,
    menu: true,
    group: 'health',
    desc: 'Alta formazione per quadri e dirigenti del settore sanitario.',
  },

  // ── Investimenti ──────────────────────────────────────────────
  {
    name: 'Investimenti',
    path: '/investimenti',
    element: <Investimenti />,
    menu: false,
    group: 'investimenti',
    desc: 'Hub investimenti: Startup, M&A, Infrastrutture, Club Deal, Sviluppo Globale.',
  },
  {
    name: 'Startup & PoC',
    path: '/startup-poc',
    element: <StartupPoc />,
    menu: true,
    group: 'investimenti',
    desc: 'Selezione e supporto a startup innovative in ambito healthcare.',
  },
  {
    name: 'M&A e Due Diligence',
    path: '/ma-due-diligence',
    element: <MaDueDiligence />,
    menu: true,
    group: 'investimenti',
    desc: 'Operazioni di acquisizione, fusione e disinvestimento in sanità.',
  },
  {
    name: 'Nuove Infrastrutture',
    path: '/nuove-infrastrutture',
    element: <NuoveInfrastrutture />,
    menu: true,
    group: 'investimenti',
    desc: 'Project financing e master plan per poli ospedalieri e diagnostici.',
  },
  {
    name: 'Club Deal',
    path: '/club-deal',
    element: <ClubDeal />,
    menu: true,
    group: 'investimenti',
    desc: 'Operazioni di investimento selezionate con investitori qualificati.',
  },
  {
    name: 'Sviluppo Globale',
    path: '/progetti-esteri',
    element: <ProgettiEsteri />,
    menu: true,
    group: 'investimenti',
    desc: 'Internazionalizzazione e progetti con Commissione Europea e ONU.',
  },

  // ── Global Projects ───────────────────────────────────────────
  {
    name: 'Global Projects',
    path: '/global-projects',
    element: <GlobalProjects />,
    menu: true,
    group: 'globalprojects',
    desc: 'Economia circolare nell\'healthcare, Northern Metropolis HK e Smart Cities.',
  },
  {
    name: 'Northern Metropolis',
    path: '/northern-metropolis',
    element: <NorthernMetropolis />,
    menu: true,
    group: 'globalprojects',
    desc: 'Il nuovo polo urbano di Hong Kong al confine con Shenzhen e la Greater Bay Area.',
  },

  // ── Istituzionale ──────────────────────────────────────────────
  {
    name: 'Chi Siamo',
    path: '/chi-siamo',
    element: <ChiSiamo />,
    menu: true,
    group: 'istituzionale',
  },
  {
    name: 'Contatti',
    path: '/contatti',
    element: <Contatti />,
    menu: true,
    group: 'istituzionale',
  },
];

export default routes;
